var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DialogContainer",
    {
      attrs: {
        title: "Edit Activity",
        icon: "edit",
        showDialog: _vm.showDialog,
        toolbarActions: [
          {
            text: "Save",
            icon: "save",
            buttonColor: "success",
            emitEvent: "onSubmitClicked",
            showIsLoading: true,
            isDisabledFunc: () => !_vm.isFormValid,
          },
          {
            text: "Cancel",
            depressed: true,
            emitEvent: "onCancelClicked",
          },
        ],
        isLoading: _vm.isLoading,
      },
      on: {
        onCancelClicked: _vm.onCancelClicked,
        onSubmitClicked: _vm.onSubmitClicked,
      },
    },
    [
      _c(
        "v-container",
        { attrs: { "pa-0": "", "grid-list-lg": "" } },
        [
          _c(
            "v-form",
            {
              ref: "form",
              model: {
                value: _vm.isFormValid,
                callback: function ($$v) {
                  _vm.isFormValid = $$v
                },
                expression: "isFormValid",
              },
            },
            [
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c("ControlAutoComplete", {
                        attrs: {
                          items: _vm.enabledActivityTypeList,
                          autocomplete: "",
                          "item-text": "name",
                          "item-value": "id",
                          clearable: "",
                          label: "Activity Type*",
                          disabled: _vm.isLoading,
                          rules: [(v) => !!v || "Required"],
                        },
                        model: {
                          value: _vm.typeId,
                          callback: function ($$v) {
                            _vm.typeId = $$v
                          },
                          expression: "typeId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.type && _vm.type.isStatusChange
                    ? _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c("ControlAutoComplete", {
                            attrs: {
                              items: _vm.availableAssetStatuses,
                              autocomplete: "",
                              "item-text": "name",
                              "item-value": "id",
                              clearable: "",
                              label: "Equipment Status*",
                              disabled: !_vm.typeId || _vm.isLoading,
                              rules: [(v) => !!v || "Required"],
                            },
                            model: {
                              value: _vm.statusId,
                              callback: function ($$v) {
                                _vm.statusId = $$v
                              },
                              expression: "statusId",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type && _vm.type.isLocationChange
                    ? _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c("ControlAutoComplete", {
                            attrs: {
                              items: _vm.enabledLocationList,
                              "item-text": (location) => {
                                return (
                                  "" +
                                  location.name +
                                  " - " +
                                  _vm._entityPropertyValueByName({
                                    entityList: _vm.clientList,
                                    idKey: "id",
                                    idValue: location.clientIdOwner,
                                    propertyKey: "name",
                                  })
                                )
                              },
                              "item-value": "id",
                              clearable: "",
                              label: "Location*",
                              disabled: _vm.isLoading,
                              rules: [(v) => !!v || "Required"],
                            },
                            model: {
                              value: _vm.locationId,
                              callback: function ($$v) {
                                _vm.locationId = $$v
                              },
                              expression: "locationId",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", md6: "" } },
                    [
                      _c("ControlDatePicker", {
                        attrs: {
                          label: "Activity Date*",
                          disabled: _vm.isLoading,
                          rules: [(v) => !!v || "Required"],
                        },
                        model: {
                          value: _vm.datePerformedOn,
                          callback: function ($$v) {
                            _vm.datePerformedOn = $$v
                          },
                          expression: "datePerformedOn",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", md6: "" } },
                    [
                      _c("ControlTimePicker", {
                        attrs: {
                          label: "Activity Time*",
                          disabled: _vm.isLoading,
                          rules: [(v) => !!v || "Required"],
                        },
                        model: {
                          value: _vm.timePerformedOn,
                          callback: function ($$v) {
                            _vm.timePerformedOn = $$v
                          },
                          expression: "timePerformedOn",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c("ControlAutoComplete", {
                        attrs: {
                          items: _vm.enabledUserList,
                          "item-text": "name",
                          "item-value": "id",
                          clearable: "",
                          label: "Performed By*",
                          disabled: _vm.isLoading,
                          rules: [(v) => !!v || "Required"],
                        },
                        model: {
                          value: _vm.userIdPerformedBy,
                          callback: function ($$v) {
                            _vm.userIdPerformedBy = $$v
                          },
                          expression: "userIdPerformedBy",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c("ControlTextArea", {
                        attrs: { label: "Comments", disabled: _vm.isLoading },
                        model: {
                          value: _vm.comments,
                          callback: function ($$v) {
                            _vm.comments = $$v
                          },
                          expression: "comments",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c("ControlFileInput", {
                        attrs: { label: "Comments", disabled: _vm.isLoading },
                        model: {
                          value: _vm.files,
                          callback: function ($$v) {
                            _vm.files = $$v
                          },
                          expression: "files",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("small", [_vm._v("*indicates required field")]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }